var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "columns is-multiline" }, [
      _c("div", { staticClass: "column is-narrow" }, [
        _c(
          "p",
          { staticClass: "field" },
          [
            _c(
              "router-link",
              { staticClass: "button is-grey", attrs: { to: "/stock" } },
              [
                _c("b-icon", {
                  attrs: { icon: "arrow-left", size: "is-small" },
                }),
                _c("span", [_vm._v(_vm._s(_vm.$t("global.back")))]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "column" }, [
        _c("nav", { staticClass: "level" }, [
          _c("div", { staticClass: "level-item has-text-centered" }, [
            _c("div", [
              _c("p", { staticClass: "heading" }, [
                _vm._v(" " + _vm._s(_vm.$t("global.name")) + " "),
              ]),
              _c("p", [_vm._v(_vm._s(_vm.partner.name || "N/A"))]),
            ]),
          ]),
          _c("div", { staticClass: "level-item has-text-centered" }, [
            _c("div", [
              _c("p", { staticClass: "heading" }, [
                _vm._v(" " + _vm._s(_vm.$t("global.country")) + " "),
              ]),
              _c("p", [_vm._v(_vm._s(_vm.partner.country || "N/A"))]),
            ]),
          ]),
          _c("div", { staticClass: "level-item has-text-centered" }, [
            _c("div", [
              _c("p", { staticClass: "heading" }, [
                _vm._v(" " + _vm._s(_vm.$t("global.city")) + " "),
              ]),
              _c("p", [_vm._v(_vm._s(_vm.partner.city || "N/A"))]),
            ]),
          ]),
          _c("div", { staticClass: "level-item has-text-centered" }, [
            _c("div", [
              _c("p", { staticClass: "heading" }, [
                _vm._v(" " + _vm._s(_vm.$t("global.total")) + " "),
              ]),
              _c("p", [_vm._v(_vm._s(_vm.total))]),
            ]),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "columns" }, [
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c("gridManager", {
            attrs: { "grid-id": _vm.gridId, profiles: _vm.gridProfiles },
            on: {
              save: _vm.saveProfile,
              create: _vm.createProfile,
              update: _vm.updateProfile,
              select: _vm.selectProfile,
              delete: _vm.deleteProfile,
            },
          }),
          _c("ag-grid-vue", {
            staticClass: "ag-theme-balham",
            staticStyle: { width: "100%", height: "750px" },
            attrs: {
              id: _vm.gridId,
              "grid-options": _vm.gridOptions,
              "get-child-count": _vm.getChildCount,
              pagination: true,
              "pagination-auto-page-size": true,
              "side-bar": ["columns"],
              "cache-overflow-size": 0,
              "row-selection": "multiple",
              "multi-sort-key": "ctrl",
              "get-context-menu-items": _vm.getContextMenuItems,
              modules: _vm.modules,
            },
            on: { "grid-ready": _vm.onGridReady },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }